import "./styles/Footer.css";
import { Helmet } from "react-helmet";

function Footer() {
  return (
    
    <div className="mainFooterDiv">
      <Helmet>
        <meta
          name="description"
          content="Kontaktirajte nas za rezervaciju Apartmana Stari Vlah Zlatibor. Smešten u mirnom delu Zlatibora, apartman nudi parking i sve pogodnosti za udoban boravak." 
        />
        <meta
          name="keywords"
            content="kontakt Zlatibor smeštaj, apartman Zlatibor lokacija, rezervacija smeštaja Zlatibor, najbolji apartmani Zlatibor, povoljan smeštaj Zlatibor, luksuzni apartmani Zlatibor, Apartman Stari Vlah kontakt, apartman Zlatibor parking"
        />
      </Helmet>
      <div className="firstFooterDiv">
        <img src="/images/logoKvadrat.webp" className="footerLogo" loading="lazy" alt="Apartman Stari Vlah Zlatibor - Logo" />
        <h1 className="footerHeader">Apartman Stari Vlah Zlatibor</h1>
        <h2 className="footerHeader2">🌲 Idealno mesto za uživanje u Zlatiboru 🌲</h2>
      </div>
      <div className="footerNavDiv">
        <a href="/questions" className="footerLink">Često postavljena pitanja</a>
        <a href="/reviews" className="footerLink">Recenzije gostiju</a>
        <a href="/blog" className="footerLink">Blog</a>
      </div>

      <div className="footerContactDiv">
        <h2 className="footerContactHeader">Kontakt</h2>
        <div className="footerContactRowDiv">
          <img src="/images/distanceOrange.png" className="footerIcon" loading="lazy" alt="Ikona lokacije - Apartman Stari Vlah Zlatibor"/>
          <p className="footerContactParagraph">
            Nikole Altomanovića 6, Zlatibor
          </p>
        </div>
        <div className="footerContactRowDiv">
          <img src="/images/contactOrange.png" className="footerIcon" loading="lazy" alt="Kontakt ikona - Apartman Stari Vlah Zlatibor" />
          <p
            className="footerContactParagraph"
            style={{ letterSpacing: "0.06rem" }}
          >
            +(381)61 68 36 736 | +(381)61 24 23 547
          </p>
        </div>
        <div className="footerContactRowDiv">
          <img src="/images/instagramOrange.png" className="footerIcon" loading="lazy" alt="Instagram ikona - Apartman Stari Vlah Zlatibor"/>
          <p
            className="footerContactParagraph"
            style={{ letterSpacing: "0.06rem" }}
          >
            starivlah_zlatibor
          </p>
        </div>
      </div>
      <div className="creditsDiv">
        <p className="creditsParagraph">© 2025 Stari Vlah. Built by </p>
        <p className="authorParagraph"  onClick={() => window.open("https://www.linkedin.com/in/dusan-bondokic-9b214318b/", "_blank")} aria-label="LinkedIn profile of DuleBondok">DuleBondok</p>
      </div>
      
    </div>
  );
}

export default Footer;
